import { useAtom } from 'jotai';

import { useDeviceName } from 'lib/api/myRobot';

import { RobotStream } from '../../hooks/ros/services';
import { selectedCameraSourceAtom } from './robot-control.atom';

// used for setting the selected camera source on primary stream
export function useSelectedCameraSource(stream: RobotStream) {
  const { deviceName } = useDeviceName();
  // per device and per stream global state
  return useAtom(selectedCameraSourceAtom(`${deviceName}-${stream}`));
}
